import {Record} from 'immutable';

const IconSet = Record({
  id: null,
  link: null,
  token: null,
  icons: [],
  name: '',
  slug: '',
  optimizedFor: '',
  version: '',
  creatorName: '',
  updatedAt: '',
  custom: false,
  premium: false,
  price: 0,
})

export default IconSet;



// WEBPACK FOOTER //
// ./app/javascript/records/IconSet.js